import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { SrxApi } from '../../api/SrxApi';

const useSaveOrderReturn = () => {
    const { mutate: saveOrderReturn, isLoading } = useMutation(
        async (payload) => {
            const response = await SrxApi.post('/orderReturns/save-return', payload);
            return response?.data;
        },
        {
            onSuccess: (data) => {
                const message = data?.message ?? data?.data?.message ?? 'Order return saved successfully!';
                toast.success(message);
            },
            onError: (error) => {
                const errorMessage =
                    error?.response?.data?.message || error?.message || 'Failed to save order return';
                toast.error(errorMessage);
            },
        }
    );

    return { saveOrderReturn, isSaveOrderReturnLoading: isLoading };
};

export default useSaveOrderReturn;
